<div>
  <!--<h2>Gestión De Usuarios</h2>-->
  <div class="contenedor-form" *ngIf="items">
    <app-dynamic-form [items]="items" [descripcion]="descripcion" [parametrosDestino]="parametrosDestino" [procedimientoDestino]="procedimientoDestino"></app-dynamic-form>
  </div>
  <div class="contenedor-form" *ngIf="!items">    
    <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
  </div>
</div>